query allSoccerPlayers(
  $first: Int,
  $offset: Int,
  $filter: SoccerPlayerFilter,
  $condition: SoccerPlayerCondition
  ) {
  players: allSoccerPlayers(
      first: $first,
      offset: $offset,
      filter: $filter,
      condition: $condition
    ) {
    nodes {
      playerMappings: soccerPlayerMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingId
          mappingType
          createdAt
          createdBy
          updatedAt 
          updatedBy
          playerIndex
          playerTeamMapping: playerTeamMappingsByFeedAndPlayerExtId {
            nodes {
              discriminator
              team: soccerTeamMapping { 
                extRef
              }
            }
          }
        }
      }
      name
      source
      playerId
      playerIndex
      position
    }
    totalCount
  }
}
